import { contentAssignmentApi } from 'src/features/content-assignment/services/contentAssignmentService';
import { appRolesApi } from 'src/features/application-roles/services/appRolesService';
import { bulkUserImportApi } from 'src/features/bulk-users-import/services/bulkUserImportService';
import { authenticationApi } from 'src/features/authentication-v2/services/authenticationService';
import { minimalResourcesAccessApi } from 'src/features/resources-assignment/services/minimalResourcesAccessService';

const rootMiddleware = {
    [contentAssignmentApi.reducerPath]: contentAssignmentApi.middleware,
    [appRolesApi.reducerPath]: appRolesApi.middleware,
    [bulkUserImportApi.reducerPath]: bulkUserImportApi.middleware,
    [authenticationApi.reducerPath]: authenticationApi.middleware,
    [minimalResourcesAccessApi.reducerPath]: minimalResourcesAccessApi.middleware,
};

export default rootMiddleware;
